module.exports = __webpack_public_path__ + "nc_static/media/card_refresh.fb2859df.svg";